import { ArticleState } from './reducer';
import { RootState } from '../../../store';
import { getArticleTargeting, toSlotTargeting } from '../../../lib/adTargeting';
import adSizes from '../adSizes';
import { Ads } from '../../../components/presentational/Ad';

interface State extends RootState {
  article: ArticleState;
}

export type Brand = State['article']['brand'];
export type Article = State['article']['article'];
export type AdConfig = State['article']['adConfig'];
export type SocialMedia = State['article']['socialMedia'];
export type SuggestedArticlesUrl = State['article']['suggestedArticlesUrl'];
export type HolidaysUrl = State['article']['holidaysUrl'];

export const brandSelector = ({ article: { brand } }: State): Brand => brand;

export const articleSelector = ({ article: { article } }: State): Article =>
  article;

export const adConfigSelector = ({ article: { adConfig } }: State): AdConfig =>
  adConfig;

export const socialMediaSelector = ({
  article: { socialMedia },
}: State): SocialMedia => socialMedia;

export const suggestedArticlesUrlSelector = ({
  article: { suggestedArticlesUrl },
}: State): SuggestedArticlesUrl => suggestedArticlesUrl;

export const holidaysUrlSelector = ({
  article: { holidaysUrl },
}: State): SuggestedArticlesUrl => holidaysUrl;

export const faviconSelector = ({ article: { faviconUrl } }: State): string =>
  faviconUrl;

export const holidaysSelector = ({ article: { holidays } }: State) => holidays;

export const suggestedArticlesSelector = ({
  article: { suggestedArticles = [] },
}: State) => suggestedArticles;

export const hideAdsSelector = ({ article: { hideAds } }: State): boolean =>
  !!hideAds;

export const hideCommentsSelector = ({
  article: { hideComments },
}: State): boolean => !!hideComments;

export const hideStickyRecircSelector = ({
  article: { hideStickyRecirc },
}: State): boolean => !!hideStickyRecirc;

export const adsSelector = ({
  article: { adConfig, article, hideAds },
}: State): Ads => {
  if (hideAds) return {};

  const targeting = toSlotTargeting(getArticleTargeting(article));

  return Object.keys(adConfig.units).reduce(
    (acc, slot) => ({
      ...acc,
      [slot]: {
        ...adSizes[slot],
        adUnitPath: adConfig.units[slot],
        targeting,
      },
    }),
    {}
  );
};

export const showLinkbyPubFeedSelector = ({
  article: { showLinkbyPubFeed },
}: State): boolean => !!showLinkbyPubFeed;
